export const apiKey = window.RUNTIME_API_URL;
// export const apiKey = "https://admin.amancredits.com/api";
// export const apiKey = "https://newcontracts.amancredits.com/api";
